/**
 * E5. Ставка на матч: таблица восьми команд с честным шансом и
 * коэффициентом (маржа уже внутри), тап по команде, ставка ползунком,
 * «Поставить». В «restricted» странах — строка о комиссии букмекера.
 * Итог известен в конце года в журнале (разрешает движок).
 */
import { t } from '@life/i18n';
import { BETS_MARGIN, type BetsInput, type BetsState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Bet, betCap, useBet } from './ui/Bet';

export function Bets({ state, life, onInput }: MinigameScreenProps<BetsInput, BetsState>) {
  const cap = betCap(state.maxBet, life.money);
  const [bet, setBet] = useBet(cap);
  const [team, setTeam] = useState<number | null>(null);
  const canPlace = team !== null && bet > 0;

  return (
    <>
      <p class="hint">{t('ui.minigame.bets.margin', { p: Math.round(BETS_MARGIN * 100) })}</p>
      {state.commission > 0 && <p class="hint">{t('ui.minigame.bets.commission', { p: Math.round(state.commission * 100) })}</p>}
      <div class="teams" role="group" aria-label={t('ui.minigame.bets.pick')}>
        {state.teams.map((tm) => (
          <button key={tm.id} type="button" class={tm.id === team ? 'btn active' : 'btn'} aria-pressed={tm.id === team} onClick={() => setTeam(tm.id)}>
            <span>{t(tm.nameKey)}</span>
            <span class="mono">{t('ui.minigame.bets.row', { p: Math.round(tm.p * 100), odds: tm.odds.toFixed(2) })}</span>
          </button>
        ))}
      </div>
      <Bet cap={cap} value={bet} onChange={setBet} />
      <button type="button" class="btn accent block" disabled={!canPlace} onClick={() => team !== null && onInput({ team, bet })}>
        {t('ui.minigame.bets.place')}
      </button>
    </>
  );
}
